import { useCreatePaymentMutation } from '../../api/api'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'

const SubscriptionOptions = ({ buttonLabel = 'Purchase Subscription' }) => {
  const [createPayment, { isLoading }] = useCreatePaymentMutation()
  async function handleCreatePayment(type) {
    try {
      const res = await createPayment(type)
      const url = res?.data?.url
      if (url) {
        window.location = url
      }
    } catch (err) {
      console.error(err)
    }
  }
  return (
    <div className="subscription-options text-purple">
      <div className="flex">
        <div className="flex-fill mr-4 p-6 bg-salmon rounded flex flex-col">
          <h2 className="font-bold">Monthly</h2>
          <div className="flex items-center mt-4">
            <div className="font-heading text-5xl font-bold pt-2">$5</div>
            <div className="">
              <div className="ml-4 bg-purple text-salmon rounded-half px-4 py-2 inline-block font-bold">
                per month
              </div>
            </div>
          </div>
          <div className="flex-1"></div>
          <div className="mt-12">
            <button
              className="button w-full bg-purple-light hover:bg-purple-light-med relative"
              disabled={isLoading}
              onClick={() => handleCreatePayment('monthly')}
            >
              {isLoading ? <LoadingSpinner /> : buttonLabel}
            </button>
          </div>
        </div>
        <div className="flex-fill ml-4 p-6 bg-neon-blue rounded flex flex-col">
          <h2 className="font-bold">Annual</h2>

          <div className="flex items-center mt-4">
            <div className="font-heading text-4xl font-bold pt-2 mr-2 relative">
              $60
              <div className="bg-purple absolute w-full top-[22px] left-0 rounded-half h-[5px]"></div>
            </div>
            <div className="font-heading text-5xl font-bold pt-2">$50</div>
            <div className="">
              <div className="ml-4 bg-purple text-neon-blue rounded-half px-4 py-2 inline-block font-bold">
                per year
              </div>
            </div>
          </div>
          <div className="font-bold text-sm mt-2">Save 17%</div>
          <div className="mt-12">
            <button
              className="button w-full bg-purple-light hover:bg-purple-light-med relative"
              disabled={isLoading}
              onClick={() => handleCreatePayment('annual')}
            >
              {isLoading ? <LoadingSpinner /> : buttonLabel}
            </button>
          </div>
        </div>
      </div>

      <div className="text-white text-right mt-4">Prices are in USD.</div>
    </div>
  )
}

export default SubscriptionOptions
